'use strict';

var assetsLoader = require('./group');
assetsLoader.stats = require('./stats');

module.exports = assetsLoader;



//////////////////
// WEBPACK FOOTER
// ./node_modules/assets-loader/src/index.js
// module id = 105
// module chunks = 0